/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SsoIndexRouteImport } from './routes/sso/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as authAdminRouteRouteImport } from './routes/(auth)/admin/route'
import { Route as authProjectsIndexRouteImport } from './routes/(auth)/projects/index'
import { Route as authAdminIndexRouteImport } from './routes/(auth)/admin/index'
import { Route as authProjectsProjectVersionIdRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/route'
import { Route as authProjectsProjectVersionIdSchedulesRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/schedules/route'
import { Route as authProjectsProjectVersionIdReInspectionsRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/route'
import { Route as authProjectsProjectVersionIdQuotationRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/quotation/route'
import { Route as authProjectsProjectVersionIdInspectionPlansRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/inspection-plans/route'
import { Route as authProjectsProjectVersionIdDocumentsRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/documents/route'
import { Route as authProjectsProjectVersionIdApplicationsRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/route'
import { Route as authAdminorganisationsOrganisationRouteRouteImport } from './routes/(auth)/admin/(organisations)/organisation/route'
import { Route as authProjectsProjectVersionIdSchedulesIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/schedules/index'
import { Route as authProjectsProjectVersionIdReInspectionsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/index'
import { Route as authProjectsProjectVersionIdQuotationIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/quotation/index'
import { Route as authProjectsProjectVersionIdDocumentsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/documents/index'
import { Route as authAdminorganisationsOrganisationsIndexRouteImport } from './routes/(auth)/admin/(organisations)/organisations/index'
import { Route as authAdminorganisationsOrganisationIndexRouteImport } from './routes/(auth)/admin/(organisations)/organisation/index'
import { Route as authProjectsProjectVersionIdReInspectionsSummaryRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/summary/route'
import { Route as authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/route'
import { Route as authProjectsProjectVersionIdReInspectionsInformationRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/information/route'
import { Route as authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/controlpoints/route'
import { Route as authProjectsProjectVersionIdReInspectionsCompletionRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/completion/route'
import { Route as authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/those-involved/route'
import { Route as authAdminorganisationsOrganisationTemplatesRouteRouteImport } from './routes/(auth)/admin/(organisations)/organisation/templates/route'
import { Route as authProjectsProjectVersionIdTestProjectFilesIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/test.project-files.index'
import { Route as authProjectsProjectVersionIdReInspectionsSummaryIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/summary/index'
import { Route as authProjectsProjectVersionIdReInspectionsPvInvertersIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/index'
import { Route as authProjectsProjectVersionIdReInspectionsInformationIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/information/index'
import { Route as authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/final-circuits/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/index'
import { Route as authProjectsProjectVersionIdReInspectionsControlpointsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/controlpoints/index'
import { Route as authProjectsProjectVersionIdReInspectionsCompletionIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/completion/index'
import { Route as authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/inspection-plans/plan-of-approach/index'
import { Route as authProjectsProjectVersionIdInspectionPlansInformationIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/inspection-plans/information/index'
import { Route as authProjectsProjectVersionIdApplicationsRequestConcerningIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/request-concerning/index'
import { Route as authProjectsProjectVersionIdApplicationsRecapIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/recap/index'
import { Route as authProjectsProjectVersionIdApplicationsObjectsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/objects/index'
import { Route as authProjectsProjectVersionIdApplicationsDrawingsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/drawings/index'
import { Route as authAdminorganisationsOrganisationInformationIndexRouteImport } from './routes/(auth)/admin/(organisations)/organisation/information/index'
import { Route as authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/route'
import { Route as authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/route'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/route'
import { Route as authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/index'
import { Route as authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/those-involved/users/index'
import { Route as authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/those-involved/owner/index'
import { Route as authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/those-involved/managers/index'
import { Route as authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/applications/those-involved/client/index'
import { Route as authAdminorganisationsOrganisationTemplatesTemplateIdIndexRouteImport } from './routes/(auth)/admin/(organisations)/organisation/templates/$templateId/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/route'
import { Route as authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information/index'
import { Route as authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements/index'
import { Route as authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRouteImport } from './routes/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations/index'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoIndexRoute = SsoIndexRouteImport.update({
  id: '/sso/',
  path: '/sso/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const authAdminRouteRoute = authAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => authRouteRoute,
} as any)
const authProjectsIndexRoute = authProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => authRouteRoute,
} as any)
const authAdminIndexRoute = authAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authAdminRouteRoute,
} as any)
const authProjectsProjectVersionIdRouteRoute =
  authProjectsProjectVersionIdRouteRouteImport.update({
    id: '/projects/$projectVersionId',
    path: '/projects/$projectVersionId',
    getParentRoute: () => authRouteRoute,
  } as any)
const authProjectsProjectVersionIdSchedulesRouteRoute =
  authProjectsProjectVersionIdSchedulesRouteRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => authProjectsProjectVersionIdRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsRouteRoute =
  authProjectsProjectVersionIdReInspectionsRouteRouteImport.update({
    id: '/re-inspections',
    path: '/re-inspections',
    getParentRoute: () => authProjectsProjectVersionIdRouteRoute,
  } as any)
const authProjectsProjectVersionIdQuotationRouteRoute =
  authProjectsProjectVersionIdQuotationRouteRouteImport.update({
    id: '/quotation',
    path: '/quotation',
    getParentRoute: () => authProjectsProjectVersionIdRouteRoute,
  } as any)
const authProjectsProjectVersionIdInspectionPlansRouteRoute =
  authProjectsProjectVersionIdInspectionPlansRouteRouteImport.update({
    id: '/inspection-plans',
    path: '/inspection-plans',
    getParentRoute: () => authProjectsProjectVersionIdRouteRoute,
  } as any)
const authProjectsProjectVersionIdDocumentsRouteRoute =
  authProjectsProjectVersionIdDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => authProjectsProjectVersionIdRouteRoute,
  } as any)
const authProjectsProjectVersionIdApplicationsRouteRoute =
  authProjectsProjectVersionIdApplicationsRouteRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => authProjectsProjectVersionIdRouteRoute,
  } as any)
const authAdminorganisationsOrganisationRouteRoute =
  authAdminorganisationsOrganisationRouteRouteImport.update({
    id: '/(organisations)/organisation',
    path: '/organisation',
    getParentRoute: () => authAdminRouteRoute,
  } as any)
const authProjectsProjectVersionIdSchedulesIndexRoute =
  authProjectsProjectVersionIdSchedulesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authProjectsProjectVersionIdSchedulesRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsIndexRoute =
  authProjectsProjectVersionIdReInspectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
  } as any)
const authProjectsProjectVersionIdQuotationIndexRoute =
  authProjectsProjectVersionIdQuotationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authProjectsProjectVersionIdQuotationRouteRoute,
  } as any)
const authProjectsProjectVersionIdDocumentsIndexRoute =
  authProjectsProjectVersionIdDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authProjectsProjectVersionIdDocumentsRouteRoute,
  } as any)
const authAdminorganisationsOrganisationsIndexRoute =
  authAdminorganisationsOrganisationsIndexRouteImport.update({
    id: '/(organisations)/organisations/',
    path: '/organisations/',
    getParentRoute: () => authAdminRouteRoute,
  } as any)
const authAdminorganisationsOrganisationIndexRoute =
  authAdminorganisationsOrganisationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authAdminorganisationsOrganisationRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsSummaryRouteRoute =
  authProjectsProjectVersionIdReInspectionsSummaryRouteRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute =
  authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteImport.update({
    id: '/pv-inverters',
    path: '/pv-inverters',
    getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsInformationRouteRoute =
  authProjectsProjectVersionIdReInspectionsInformationRouteRouteImport.update({
    id: '/information',
    path: '/information',
    getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsControlpointsRouteRoute =
  authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteImport.update(
    {
      id: '/controlpoints',
      path: '/controlpoints',
      getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsCompletionRouteRoute =
  authProjectsProjectVersionIdReInspectionsCompletionRouteRouteImport.update({
    id: '/completion',
    path: '/completion',
    getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
  } as any)
const authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute =
  authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteImport.update({
    id: '/those-involved',
    path: '/those-involved',
    getParentRoute: () => authProjectsProjectVersionIdApplicationsRouteRoute,
  } as any)
const authAdminorganisationsOrganisationTemplatesRouteRoute =
  authAdminorganisationsOrganisationTemplatesRouteRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => authAdminorganisationsOrganisationRouteRoute,
  } as any)
const authProjectsProjectVersionIdTestProjectFilesIndexRoute =
  authProjectsProjectVersionIdTestProjectFilesIndexRouteImport.update({
    id: '/test/project-files/',
    path: '/test/project-files/',
    getParentRoute: () => authProjectsProjectVersionIdRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsSummaryIndexRoute =
  authProjectsProjectVersionIdReInspectionsSummaryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      authProjectsProjectVersionIdReInspectionsSummaryRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute =
  authProjectsProjectVersionIdReInspectionsPvInvertersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsInformationIndexRoute =
  authProjectsProjectVersionIdReInspectionsInformationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      authProjectsProjectVersionIdReInspectionsInformationRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute =
  authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRouteImport.update(
    {
      id: '/final-circuits/',
      path: '/final-circuits/',
      getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRouteImport.update(
    {
      id: '/distributionboards/',
      path: '/distributionboards/',
      getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute =
  authProjectsProjectVersionIdReInspectionsControlpointsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsControlpointsRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsCompletionIndexRoute =
  authProjectsProjectVersionIdReInspectionsCompletionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      authProjectsProjectVersionIdReInspectionsCompletionRouteRoute,
  } as any)
const authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute =
  authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRouteImport.update(
    {
      id: '/plan-of-approach/',
      path: '/plan-of-approach/',
      getParentRoute: () =>
        authProjectsProjectVersionIdInspectionPlansRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdInspectionPlansInformationIndexRoute =
  authProjectsProjectVersionIdInspectionPlansInformationIndexRouteImport.update(
    {
      id: '/information/',
      path: '/information/',
      getParentRoute: () =>
        authProjectsProjectVersionIdInspectionPlansRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute =
  authProjectsProjectVersionIdApplicationsRequestConcerningIndexRouteImport.update(
    {
      id: '/request-concerning/',
      path: '/request-concerning/',
      getParentRoute: () => authProjectsProjectVersionIdApplicationsRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdApplicationsRecapIndexRoute =
  authProjectsProjectVersionIdApplicationsRecapIndexRouteImport.update({
    id: '/recap/',
    path: '/recap/',
    getParentRoute: () => authProjectsProjectVersionIdApplicationsRouteRoute,
  } as any)
const authProjectsProjectVersionIdApplicationsObjectsIndexRoute =
  authProjectsProjectVersionIdApplicationsObjectsIndexRouteImport.update({
    id: '/objects/',
    path: '/objects/',
    getParentRoute: () => authProjectsProjectVersionIdApplicationsRouteRoute,
  } as any)
const authProjectsProjectVersionIdApplicationsDrawingsIndexRoute =
  authProjectsProjectVersionIdApplicationsDrawingsIndexRouteImport.update({
    id: '/drawings/',
    path: '/drawings/',
    getParentRoute: () => authProjectsProjectVersionIdApplicationsRouteRoute,
  } as any)
const authAdminorganisationsOrganisationInformationIndexRoute =
  authAdminorganisationsOrganisationInformationIndexRouteImport.update({
    id: '/information/',
    path: '/information/',
    getParentRoute: () => authAdminorganisationsOrganisationRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRoute =
  authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteImport.update(
    {
      id: '/$inverterId',
      path: '/$inverterId',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute =
  authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteImport.update(
    {
      id: '/final-circuits/$finalCircuitId',
      path: '/final-circuits/$finalCircuitId',
      getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteImport.update(
    {
      id: '/distributionboards/$distributionboardId',
      path: '/distributionboards/$distributionboardId',
      getParentRoute: () => authProjectsProjectVersionIdReInspectionsRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute =
  authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute =
  authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRouteImport.update(
    {
      id: '/users/',
      path: '/users/',
      getParentRoute: () =>
        authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute =
  authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRouteImport.update(
    {
      id: '/owner/',
      path: '/owner/',
      getParentRoute: () =>
        authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute =
  authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRouteImport.update(
    {
      id: '/managers/',
      path: '/managers/',
      getParentRoute: () =>
        authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute =
  authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRouteImport.update(
    {
      id: '/client/',
      path: '/client/',
      getParentRoute: () =>
        authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute,
    } as any,
  )
const authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute =
  authAdminorganisationsOrganisationTemplatesTemplateIdIndexRouteImport.update({
    id: '/$templateId/',
    path: '/$templateId/',
    getParentRoute: () => authAdminorganisationsOrganisationTemplatesRouteRoute,
  } as any)
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteImport.update(
    {
      id: '/board',
      path: '/board',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute =
  authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRouteImport.update(
    {
      id: '/information/',
      path: '/information/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute =
  authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRouteImport.update(
    {
      id: '/checklist/',
      path: '/checklist/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRouteImport.update(
    {
      id: '/riso/',
      path: '/riso/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRouteImport.update(
    {
      id: '/residual-current-devices/',
      path: '/residual-current-devices/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRouteImport.update(
    {
      id: '/residual-current-circuit-breakers/',
      path: '/residual-current-circuit-breakers/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRouteImport.update(
    {
      id: '/measurements/',
      path: '/measurements/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRouteImport.update(
    {
      id: '/information/',
      path: '/information/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRouteImport.update(
    {
      id: '/impedance-measurements/',
      path: '/impedance-measurements/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRouteImport.update(
    {
      id: '/final-circuit-protective-devices/',
      path: '/final-circuit-protective-devices/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRouteImport.update(
    {
      id: '/checklist/',
      path: '/checklist/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRouteImport.update(
    {
      id: '/devices/$distributionBoardDeviceId/resistance-measurements/',
      path: '/devices/$distributionBoardDeviceId/resistance-measurements/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute,
    } as any,
  )
const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRouteImport.update(
    {
      id: '/devices/$distributionBoardDeviceId/device-observations/',
      path: '/devices/$distributionBoardDeviceId/device-observations/',
      getParentRoute: () =>
        authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/admin': typeof authAdminRouteRouteWithChildren
  '/login': typeof LoginIndexRoute
  '/sso': typeof SsoIndexRoute
  '/projects/$projectVersionId': typeof authProjectsProjectVersionIdRouteRouteWithChildren
  '/admin/': typeof authAdminIndexRoute
  '/projects': typeof authProjectsIndexRoute
  '/admin/organisation': typeof authAdminorganisationsOrganisationRouteRouteWithChildren
  '/projects/$projectVersionId/applications': typeof authProjectsProjectVersionIdApplicationsRouteRouteWithChildren
  '/projects/$projectVersionId/documents': typeof authProjectsProjectVersionIdDocumentsRouteRouteWithChildren
  '/projects/$projectVersionId/inspection-plans': typeof authProjectsProjectVersionIdInspectionPlansRouteRouteWithChildren
  '/projects/$projectVersionId/quotation': typeof authProjectsProjectVersionIdQuotationRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections': typeof authProjectsProjectVersionIdReInspectionsRouteRouteWithChildren
  '/projects/$projectVersionId/schedules': typeof authProjectsProjectVersionIdSchedulesRouteRouteWithChildren
  '/admin/organisation/templates': typeof authAdminorganisationsOrganisationTemplatesRouteRouteWithChildren
  '/projects/$projectVersionId/applications/those-involved': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections/completion': typeof authProjectsProjectVersionIdReInspectionsCompletionRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections/controlpoints': typeof authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections/information': typeof authProjectsProjectVersionIdReInspectionsInformationRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections/pv-inverters': typeof authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections/summary': typeof authProjectsProjectVersionIdReInspectionsSummaryRouteRouteWithChildren
  '/admin/organisation/': typeof authAdminorganisationsOrganisationIndexRoute
  '/admin/organisations': typeof authAdminorganisationsOrganisationsIndexRoute
  '/projects/$projectVersionId/documents/': typeof authProjectsProjectVersionIdDocumentsIndexRoute
  '/projects/$projectVersionId/quotation/': typeof authProjectsProjectVersionIdQuotationIndexRoute
  '/projects/$projectVersionId/re-inspections/': typeof authProjectsProjectVersionIdReInspectionsIndexRoute
  '/projects/$projectVersionId/schedules/': typeof authProjectsProjectVersionIdSchedulesIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteWithChildren
  '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId': typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteWithChildren
  '/admin/organisation/information': typeof authAdminorganisationsOrganisationInformationIndexRoute
  '/projects/$projectVersionId/applications/drawings': typeof authProjectsProjectVersionIdApplicationsDrawingsIndexRoute
  '/projects/$projectVersionId/applications/objects': typeof authProjectsProjectVersionIdApplicationsObjectsIndexRoute
  '/projects/$projectVersionId/applications/recap': typeof authProjectsProjectVersionIdApplicationsRecapIndexRoute
  '/projects/$projectVersionId/applications/request-concerning': typeof authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute
  '/projects/$projectVersionId/inspection-plans/information': typeof authProjectsProjectVersionIdInspectionPlansInformationIndexRoute
  '/projects/$projectVersionId/inspection-plans/plan-of-approach': typeof authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute
  '/projects/$projectVersionId/re-inspections/completion/': typeof authProjectsProjectVersionIdReInspectionsCompletionIndexRoute
  '/projects/$projectVersionId/re-inspections/controlpoints/': typeof authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute
  '/projects/$projectVersionId/re-inspections/final-circuits': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute
  '/projects/$projectVersionId/re-inspections/information/': typeof authProjectsProjectVersionIdReInspectionsInformationIndexRoute
  '/projects/$projectVersionId/re-inspections/pv-inverters/': typeof authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute
  '/projects/$projectVersionId/re-inspections/summary/': typeof authProjectsProjectVersionIdReInspectionsSummaryIndexRoute
  '/projects/$projectVersionId/test/project-files': typeof authProjectsProjectVersionIdTestProjectFilesIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteWithChildren
  '/admin/organisation/templates/$templateId': typeof authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute
  '/projects/$projectVersionId/applications/those-involved/client': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute
  '/projects/$projectVersionId/applications/those-involved/managers': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute
  '/projects/$projectVersionId/applications/those-involved/owner': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute
  '/projects/$projectVersionId/applications/those-involved/users': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute
  '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/': typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute
  '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute
  '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/login': typeof LoginIndexRoute
  '/sso': typeof SsoIndexRoute
  '/projects/$projectVersionId': typeof authProjectsProjectVersionIdRouteRouteWithChildren
  '/admin': typeof authAdminIndexRoute
  '/projects': typeof authProjectsIndexRoute
  '/projects/$projectVersionId/applications': typeof authProjectsProjectVersionIdApplicationsRouteRouteWithChildren
  '/projects/$projectVersionId/inspection-plans': typeof authProjectsProjectVersionIdInspectionPlansRouteRouteWithChildren
  '/admin/organisation/templates': typeof authAdminorganisationsOrganisationTemplatesRouteRouteWithChildren
  '/projects/$projectVersionId/applications/those-involved': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteWithChildren
  '/admin/organisation': typeof authAdminorganisationsOrganisationIndexRoute
  '/admin/organisations': typeof authAdminorganisationsOrganisationsIndexRoute
  '/projects/$projectVersionId/documents': typeof authProjectsProjectVersionIdDocumentsIndexRoute
  '/projects/$projectVersionId/quotation': typeof authProjectsProjectVersionIdQuotationIndexRoute
  '/projects/$projectVersionId/re-inspections': typeof authProjectsProjectVersionIdReInspectionsIndexRoute
  '/projects/$projectVersionId/schedules': typeof authProjectsProjectVersionIdSchedulesIndexRoute
  '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteWithChildren
  '/admin/organisation/information': typeof authAdminorganisationsOrganisationInformationIndexRoute
  '/projects/$projectVersionId/applications/drawings': typeof authProjectsProjectVersionIdApplicationsDrawingsIndexRoute
  '/projects/$projectVersionId/applications/objects': typeof authProjectsProjectVersionIdApplicationsObjectsIndexRoute
  '/projects/$projectVersionId/applications/recap': typeof authProjectsProjectVersionIdApplicationsRecapIndexRoute
  '/projects/$projectVersionId/applications/request-concerning': typeof authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute
  '/projects/$projectVersionId/inspection-plans/information': typeof authProjectsProjectVersionIdInspectionPlansInformationIndexRoute
  '/projects/$projectVersionId/inspection-plans/plan-of-approach': typeof authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute
  '/projects/$projectVersionId/re-inspections/completion': typeof authProjectsProjectVersionIdReInspectionsCompletionIndexRoute
  '/projects/$projectVersionId/re-inspections/controlpoints': typeof authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute
  '/projects/$projectVersionId/re-inspections/final-circuits': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute
  '/projects/$projectVersionId/re-inspections/information': typeof authProjectsProjectVersionIdReInspectionsInformationIndexRoute
  '/projects/$projectVersionId/re-inspections/pv-inverters': typeof authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute
  '/projects/$projectVersionId/re-inspections/summary': typeof authProjectsProjectVersionIdReInspectionsSummaryIndexRoute
  '/projects/$projectVersionId/test/project-files': typeof authProjectsProjectVersionIdTestProjectFilesIndexRoute
  '/admin/organisation/templates/$templateId': typeof authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute
  '/projects/$projectVersionId/applications/those-involved/client': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute
  '/projects/$projectVersionId/applications/those-involved/managers': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute
  '/projects/$projectVersionId/applications/those-involved/owner': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute
  '/projects/$projectVersionId/applications/those-involved/users': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute
  '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId': typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute
  '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute
  '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute
  '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)': typeof authRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/(auth)/admin': typeof authAdminRouteRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/sso/': typeof SsoIndexRoute
  '/(auth)/projects/$projectVersionId': typeof authProjectsProjectVersionIdRouteRouteWithChildren
  '/(auth)/admin/': typeof authAdminIndexRoute
  '/(auth)/projects/': typeof authProjectsIndexRoute
  '/(auth)/admin/(organisations)/organisation': typeof authAdminorganisationsOrganisationRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/applications': typeof authProjectsProjectVersionIdApplicationsRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/documents': typeof authProjectsProjectVersionIdDocumentsRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/inspection-plans': typeof authProjectsProjectVersionIdInspectionPlansRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/quotation': typeof authProjectsProjectVersionIdQuotationRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections': typeof authProjectsProjectVersionIdReInspectionsRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/schedules': typeof authProjectsProjectVersionIdSchedulesRouteRouteWithChildren
  '/(auth)/admin/(organisations)/organisation/templates': typeof authAdminorganisationsOrganisationTemplatesRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/applications/those-involved': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections/completion': typeof authProjectsProjectVersionIdReInspectionsCompletionRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections/controlpoints': typeof authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections/information': typeof authProjectsProjectVersionIdReInspectionsInformationRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters': typeof authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections/summary': typeof authProjectsProjectVersionIdReInspectionsSummaryRouteRouteWithChildren
  '/(auth)/admin/(organisations)/organisation/': typeof authAdminorganisationsOrganisationIndexRoute
  '/(auth)/admin/(organisations)/organisations/': typeof authAdminorganisationsOrganisationsIndexRoute
  '/(auth)/projects/$projectVersionId/documents/': typeof authProjectsProjectVersionIdDocumentsIndexRoute
  '/(auth)/projects/$projectVersionId/quotation/': typeof authProjectsProjectVersionIdQuotationIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/': typeof authProjectsProjectVersionIdReInspectionsIndexRoute
  '/(auth)/projects/$projectVersionId/schedules/': typeof authProjectsProjectVersionIdSchedulesIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteWithChildren
  '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId': typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteWithChildren
  '/(auth)/admin/(organisations)/organisation/information/': typeof authAdminorganisationsOrganisationInformationIndexRoute
  '/(auth)/projects/$projectVersionId/applications/drawings/': typeof authProjectsProjectVersionIdApplicationsDrawingsIndexRoute
  '/(auth)/projects/$projectVersionId/applications/objects/': typeof authProjectsProjectVersionIdApplicationsObjectsIndexRoute
  '/(auth)/projects/$projectVersionId/applications/recap/': typeof authProjectsProjectVersionIdApplicationsRecapIndexRoute
  '/(auth)/projects/$projectVersionId/applications/request-concerning/': typeof authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute
  '/(auth)/projects/$projectVersionId/inspection-plans/information/': typeof authProjectsProjectVersionIdInspectionPlansInformationIndexRoute
  '/(auth)/projects/$projectVersionId/inspection-plans/plan-of-approach/': typeof authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/completion/': typeof authProjectsProjectVersionIdReInspectionsCompletionIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/controlpoints/': typeof authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/information/': typeof authProjectsProjectVersionIdReInspectionsInformationIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/': typeof authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/summary/': typeof authProjectsProjectVersionIdReInspectionsSummaryIndexRoute
  '/(auth)/projects/$projectVersionId/test/project-files/': typeof authProjectsProjectVersionIdTestProjectFilesIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteWithChildren
  '/(auth)/admin/(organisations)/organisation/templates/$templateId/': typeof authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute
  '/(auth)/projects/$projectVersionId/applications/those-involved/client/': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute
  '/(auth)/projects/$projectVersionId/applications/those-involved/managers/': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute
  '/(auth)/projects/$projectVersionId/applications/those-involved/owner/': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute
  '/(auth)/projects/$projectVersionId/applications/those-involved/users/': typeof authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/': typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist/': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information/': typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute
  '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements/': typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/admin'
    | '/login'
    | '/sso'
    | '/projects/$projectVersionId'
    | '/admin/'
    | '/projects'
    | '/admin/organisation'
    | '/projects/$projectVersionId/applications'
    | '/projects/$projectVersionId/documents'
    | '/projects/$projectVersionId/inspection-plans'
    | '/projects/$projectVersionId/quotation'
    | '/projects/$projectVersionId/re-inspections'
    | '/projects/$projectVersionId/schedules'
    | '/admin/organisation/templates'
    | '/projects/$projectVersionId/applications/those-involved'
    | '/projects/$projectVersionId/re-inspections/completion'
    | '/projects/$projectVersionId/re-inspections/controlpoints'
    | '/projects/$projectVersionId/re-inspections/information'
    | '/projects/$projectVersionId/re-inspections/pv-inverters'
    | '/projects/$projectVersionId/re-inspections/summary'
    | '/admin/organisation/'
    | '/admin/organisations'
    | '/projects/$projectVersionId/documents/'
    | '/projects/$projectVersionId/quotation/'
    | '/projects/$projectVersionId/re-inspections/'
    | '/projects/$projectVersionId/schedules/'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId'
    | '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId'
    | '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId'
    | '/admin/organisation/information'
    | '/projects/$projectVersionId/applications/drawings'
    | '/projects/$projectVersionId/applications/objects'
    | '/projects/$projectVersionId/applications/recap'
    | '/projects/$projectVersionId/applications/request-concerning'
    | '/projects/$projectVersionId/inspection-plans/information'
    | '/projects/$projectVersionId/inspection-plans/plan-of-approach'
    | '/projects/$projectVersionId/re-inspections/completion/'
    | '/projects/$projectVersionId/re-inspections/controlpoints/'
    | '/projects/$projectVersionId/re-inspections/distributionboards'
    | '/projects/$projectVersionId/re-inspections/final-circuits'
    | '/projects/$projectVersionId/re-inspections/information/'
    | '/projects/$projectVersionId/re-inspections/pv-inverters/'
    | '/projects/$projectVersionId/re-inspections/summary/'
    | '/projects/$projectVersionId/test/project-files'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board'
    | '/admin/organisation/templates/$templateId'
    | '/projects/$projectVersionId/applications/those-involved/client'
    | '/projects/$projectVersionId/applications/those-involved/managers'
    | '/projects/$projectVersionId/applications/those-involved/owner'
    | '/projects/$projectVersionId/applications/those-involved/users'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/'
    | '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/'
    | '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist'
    | '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/login'
    | '/sso'
    | '/projects/$projectVersionId'
    | '/admin'
    | '/projects'
    | '/projects/$projectVersionId/applications'
    | '/projects/$projectVersionId/inspection-plans'
    | '/admin/organisation/templates'
    | '/projects/$projectVersionId/applications/those-involved'
    | '/admin/organisation'
    | '/admin/organisations'
    | '/projects/$projectVersionId/documents'
    | '/projects/$projectVersionId/quotation'
    | '/projects/$projectVersionId/re-inspections'
    | '/projects/$projectVersionId/schedules'
    | '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId'
    | '/admin/organisation/information'
    | '/projects/$projectVersionId/applications/drawings'
    | '/projects/$projectVersionId/applications/objects'
    | '/projects/$projectVersionId/applications/recap'
    | '/projects/$projectVersionId/applications/request-concerning'
    | '/projects/$projectVersionId/inspection-plans/information'
    | '/projects/$projectVersionId/inspection-plans/plan-of-approach'
    | '/projects/$projectVersionId/re-inspections/completion'
    | '/projects/$projectVersionId/re-inspections/controlpoints'
    | '/projects/$projectVersionId/re-inspections/distributionboards'
    | '/projects/$projectVersionId/re-inspections/final-circuits'
    | '/projects/$projectVersionId/re-inspections/information'
    | '/projects/$projectVersionId/re-inspections/pv-inverters'
    | '/projects/$projectVersionId/re-inspections/summary'
    | '/projects/$projectVersionId/test/project-files'
    | '/admin/organisation/templates/$templateId'
    | '/projects/$projectVersionId/applications/those-involved/client'
    | '/projects/$projectVersionId/applications/those-involved/managers'
    | '/projects/$projectVersionId/applications/those-involved/owner'
    | '/projects/$projectVersionId/applications/those-involved/users'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId'
    | '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board'
    | '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist'
    | '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations'
    | '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements'
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/$'
    | '/(auth)/admin'
    | '/login/'
    | '/sso/'
    | '/(auth)/projects/$projectVersionId'
    | '/(auth)/admin/'
    | '/(auth)/projects/'
    | '/(auth)/admin/(organisations)/organisation'
    | '/(auth)/projects/$projectVersionId/applications'
    | '/(auth)/projects/$projectVersionId/documents'
    | '/(auth)/projects/$projectVersionId/inspection-plans'
    | '/(auth)/projects/$projectVersionId/quotation'
    | '/(auth)/projects/$projectVersionId/re-inspections'
    | '/(auth)/projects/$projectVersionId/schedules'
    | '/(auth)/admin/(organisations)/organisation/templates'
    | '/(auth)/projects/$projectVersionId/applications/those-involved'
    | '/(auth)/projects/$projectVersionId/re-inspections/completion'
    | '/(auth)/projects/$projectVersionId/re-inspections/controlpoints'
    | '/(auth)/projects/$projectVersionId/re-inspections/information'
    | '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters'
    | '/(auth)/projects/$projectVersionId/re-inspections/summary'
    | '/(auth)/admin/(organisations)/organisation/'
    | '/(auth)/admin/(organisations)/organisations/'
    | '/(auth)/projects/$projectVersionId/documents/'
    | '/(auth)/projects/$projectVersionId/quotation/'
    | '/(auth)/projects/$projectVersionId/re-inspections/'
    | '/(auth)/projects/$projectVersionId/schedules/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId'
    | '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId'
    | '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId'
    | '/(auth)/admin/(organisations)/organisation/information/'
    | '/(auth)/projects/$projectVersionId/applications/drawings/'
    | '/(auth)/projects/$projectVersionId/applications/objects/'
    | '/(auth)/projects/$projectVersionId/applications/recap/'
    | '/(auth)/projects/$projectVersionId/applications/request-concerning/'
    | '/(auth)/projects/$projectVersionId/inspection-plans/information/'
    | '/(auth)/projects/$projectVersionId/inspection-plans/plan-of-approach/'
    | '/(auth)/projects/$projectVersionId/re-inspections/completion/'
    | '/(auth)/projects/$projectVersionId/re-inspections/controlpoints/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/'
    | '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/'
    | '/(auth)/projects/$projectVersionId/re-inspections/information/'
    | '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/'
    | '/(auth)/projects/$projectVersionId/re-inspections/summary/'
    | '/(auth)/projects/$projectVersionId/test/project-files/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board'
    | '/(auth)/admin/(organisations)/organisation/templates/$templateId/'
    | '/(auth)/projects/$projectVersionId/applications/those-involved/client/'
    | '/(auth)/projects/$projectVersionId/applications/those-involved/managers/'
    | '/(auth)/projects/$projectVersionId/applications/those-involved/owner/'
    | '/(auth)/projects/$projectVersionId/applications/those-involved/users/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/'
    | '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/'
    | '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist/'
    | '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations/'
    | '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRouteRoute: typeof authRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  LoginIndexRoute: typeof LoginIndexRoute
  SsoIndexRoute: typeof SsoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso/': {
      id: '/sso/'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/admin': {
      id: '/(auth)/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof authAdminRouteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/projects/': {
      id: '/(auth)/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof authProjectsIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/admin/': {
      id: '/(auth)/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof authAdminIndexRouteImport
      parentRoute: typeof authAdminRouteRoute
    }
    '/(auth)/projects/$projectVersionId': {
      id: '/(auth)/projects/$projectVersionId'
      path: '/projects/$projectVersionId'
      fullPath: '/projects/$projectVersionId'
      preLoaderRoute: typeof authProjectsProjectVersionIdRouteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/projects/$projectVersionId/schedules': {
      id: '/(auth)/projects/$projectVersionId/schedules'
      path: '/schedules'
      fullPath: '/projects/$projectVersionId/schedules'
      preLoaderRoute: typeof authProjectsProjectVersionIdSchedulesRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections': {
      id: '/(auth)/projects/$projectVersionId/re-inspections'
      path: '/re-inspections'
      fullPath: '/projects/$projectVersionId/re-inspections'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/quotation': {
      id: '/(auth)/projects/$projectVersionId/quotation'
      path: '/quotation'
      fullPath: '/projects/$projectVersionId/quotation'
      preLoaderRoute: typeof authProjectsProjectVersionIdQuotationRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/inspection-plans': {
      id: '/(auth)/projects/$projectVersionId/inspection-plans'
      path: '/inspection-plans'
      fullPath: '/projects/$projectVersionId/inspection-plans'
      preLoaderRoute: typeof authProjectsProjectVersionIdInspectionPlansRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/documents': {
      id: '/(auth)/projects/$projectVersionId/documents'
      path: '/documents'
      fullPath: '/projects/$projectVersionId/documents'
      preLoaderRoute: typeof authProjectsProjectVersionIdDocumentsRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications': {
      id: '/(auth)/projects/$projectVersionId/applications'
      path: '/applications'
      fullPath: '/projects/$projectVersionId/applications'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdRouteRoute
    }
    '/(auth)/admin/(organisations)/organisation': {
      id: '/(auth)/admin/(organisations)/organisation'
      path: '/organisation'
      fullPath: '/admin/organisation'
      preLoaderRoute: typeof authAdminorganisationsOrganisationRouteRouteImport
      parentRoute: typeof authAdminRouteRoute
    }
    '/(auth)/projects/$projectVersionId/schedules/': {
      id: '/(auth)/projects/$projectVersionId/schedules/'
      path: '/'
      fullPath: '/projects/$projectVersionId/schedules/'
      preLoaderRoute: typeof authProjectsProjectVersionIdSchedulesIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdSchedulesRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/quotation/': {
      id: '/(auth)/projects/$projectVersionId/quotation/'
      path: '/'
      fullPath: '/projects/$projectVersionId/quotation/'
      preLoaderRoute: typeof authProjectsProjectVersionIdQuotationIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdQuotationRouteRoute
    }
    '/(auth)/projects/$projectVersionId/documents/': {
      id: '/(auth)/projects/$projectVersionId/documents/'
      path: '/'
      fullPath: '/projects/$projectVersionId/documents/'
      preLoaderRoute: typeof authProjectsProjectVersionIdDocumentsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdDocumentsRouteRoute
    }
    '/(auth)/admin/(organisations)/organisations/': {
      id: '/(auth)/admin/(organisations)/organisations/'
      path: '/organisations'
      fullPath: '/admin/organisations'
      preLoaderRoute: typeof authAdminorganisationsOrganisationsIndexRouteImport
      parentRoute: typeof authAdminRouteRoute
    }
    '/(auth)/admin/(organisations)/organisation/': {
      id: '/(auth)/admin/(organisations)/organisation/'
      path: '/'
      fullPath: '/admin/organisation/'
      preLoaderRoute: typeof authAdminorganisationsOrganisationIndexRouteImport
      parentRoute: typeof authAdminorganisationsOrganisationRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/summary': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/summary'
      path: '/summary'
      fullPath: '/projects/$projectVersionId/re-inspections/summary'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsSummaryRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters'
      path: '/pv-inverters'
      fullPath: '/projects/$projectVersionId/re-inspections/pv-inverters'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/information': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/information'
      path: '/information'
      fullPath: '/projects/$projectVersionId/re-inspections/information'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsInformationRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/controlpoints': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/controlpoints'
      path: '/controlpoints'
      fullPath: '/projects/$projectVersionId/re-inspections/controlpoints'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/completion': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/completion'
      path: '/completion'
      fullPath: '/projects/$projectVersionId/re-inspections/completion'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsCompletionRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/those-involved': {
      id: '/(auth)/projects/$projectVersionId/applications/those-involved'
      path: '/those-involved'
      fullPath: '/projects/$projectVersionId/applications/those-involved'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsRouteRoute
    }
    '/(auth)/admin/(organisations)/organisation/templates': {
      id: '/(auth)/admin/(organisations)/organisation/templates'
      path: '/templates'
      fullPath: '/admin/organisation/templates'
      preLoaderRoute: typeof authAdminorganisationsOrganisationTemplatesRouteRouteImport
      parentRoute: typeof authAdminorganisationsOrganisationRouteRoute
    }
    '/(auth)/projects/$projectVersionId/test/project-files/': {
      id: '/(auth)/projects/$projectVersionId/test/project-files/'
      path: '/test/project-files'
      fullPath: '/projects/$projectVersionId/test/project-files'
      preLoaderRoute: typeof authProjectsProjectVersionIdTestProjectFilesIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/summary/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/summary/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/summary/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsSummaryIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsSummaryRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/pv-inverters/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/information/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/information/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/information/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsInformationIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsInformationRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/'
      path: '/final-circuits'
      fullPath: '/projects/$projectVersionId/re-inspections/final-circuits'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/'
      path: '/distributionboards'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/controlpoints/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/controlpoints/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/controlpoints/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsControlpointsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsControlpointsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/completion/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/completion/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/completion/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsCompletionIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsCompletionRouteRoute
    }
    '/(auth)/projects/$projectVersionId/inspection-plans/plan-of-approach/': {
      id: '/(auth)/projects/$projectVersionId/inspection-plans/plan-of-approach/'
      path: '/plan-of-approach'
      fullPath: '/projects/$projectVersionId/inspection-plans/plan-of-approach'
      preLoaderRoute: typeof authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdInspectionPlansRouteRoute
    }
    '/(auth)/projects/$projectVersionId/inspection-plans/information/': {
      id: '/(auth)/projects/$projectVersionId/inspection-plans/information/'
      path: '/information'
      fullPath: '/projects/$projectVersionId/inspection-plans/information'
      preLoaderRoute: typeof authProjectsProjectVersionIdInspectionPlansInformationIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdInspectionPlansRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/request-concerning/': {
      id: '/(auth)/projects/$projectVersionId/applications/request-concerning/'
      path: '/request-concerning'
      fullPath: '/projects/$projectVersionId/applications/request-concerning'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsRequestConcerningIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/recap/': {
      id: '/(auth)/projects/$projectVersionId/applications/recap/'
      path: '/recap'
      fullPath: '/projects/$projectVersionId/applications/recap'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsRecapIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/objects/': {
      id: '/(auth)/projects/$projectVersionId/applications/objects/'
      path: '/objects'
      fullPath: '/projects/$projectVersionId/applications/objects'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsObjectsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/drawings/': {
      id: '/(auth)/projects/$projectVersionId/applications/drawings/'
      path: '/drawings'
      fullPath: '/projects/$projectVersionId/applications/drawings'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsDrawingsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsRouteRoute
    }
    '/(auth)/admin/(organisations)/organisation/information/': {
      id: '/(auth)/admin/(organisations)/organisation/information/'
      path: '/information'
      fullPath: '/admin/organisation/information'
      preLoaderRoute: typeof authAdminorganisationsOrganisationInformationIndexRouteImport
      parentRoute: typeof authAdminorganisationsOrganisationRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId'
      path: '/$inverterId'
      fullPath: '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId'
      path: '/final-circuits/$finalCircuitId'
      fullPath: '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId'
      path: '/distributionboards/$distributionboardId'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/those-involved/users/': {
      id: '/(auth)/projects/$projectVersionId/applications/those-involved/users/'
      path: '/users'
      fullPath: '/projects/$projectVersionId/applications/those-involved/users'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/those-involved/owner/': {
      id: '/(auth)/projects/$projectVersionId/applications/those-involved/owner/'
      path: '/owner'
      fullPath: '/projects/$projectVersionId/applications/those-involved/owner'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/those-involved/managers/': {
      id: '/(auth)/projects/$projectVersionId/applications/those-involved/managers/'
      path: '/managers'
      fullPath: '/projects/$projectVersionId/applications/those-involved/managers'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute
    }
    '/(auth)/projects/$projectVersionId/applications/those-involved/client/': {
      id: '/(auth)/projects/$projectVersionId/applications/those-involved/client/'
      path: '/client'
      fullPath: '/projects/$projectVersionId/applications/those-involved/client'
      preLoaderRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute
    }
    '/(auth)/admin/(organisations)/organisation/templates/$templateId/': {
      id: '/(auth)/admin/(organisations)/organisation/templates/$templateId/'
      path: '/$templateId'
      fullPath: '/admin/organisation/templates/$templateId'
      preLoaderRoute: typeof authAdminorganisationsOrganisationTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof authAdminorganisationsOrganisationTemplatesRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board'
      path: '/board'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information/'
      path: '/information'
      fullPath: '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist/'
      path: '/checklist'
      fullPath: '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/'
      path: '/'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso/'
      path: '/riso'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/riso'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices/'
      path: '/residual-current-devices'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers/'
      path: '/residual-current-circuit-breakers'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements/'
      path: '/measurements'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/measurements'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information/'
      path: '/information'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements/'
      path: '/impedance-measurements'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices/'
      path: '/final-circuit-protective-devices'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist/'
      path: '/checklist'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements/'
      path: '/devices/$distributionBoardDeviceId/resistance-measurements'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute
    }
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations/': {
      id: '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations/'
      path: '/devices/$distributionBoardDeviceId/device-observations'
      fullPath: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/device-observations'
      preLoaderRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRouteImport
      parentRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute
    }
  }
}

interface authAdminorganisationsOrganisationTemplatesRouteRouteChildren {
  authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute: typeof authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute
}

const authAdminorganisationsOrganisationTemplatesRouteRouteChildren: authAdminorganisationsOrganisationTemplatesRouteRouteChildren =
  {
    authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute:
      authAdminorganisationsOrganisationTemplatesTemplateIdIndexRoute,
  }

const authAdminorganisationsOrganisationTemplatesRouteRouteWithChildren =
  authAdminorganisationsOrganisationTemplatesRouteRoute._addFileChildren(
    authAdminorganisationsOrganisationTemplatesRouteRouteChildren,
  )

interface authAdminorganisationsOrganisationRouteRouteChildren {
  authAdminorganisationsOrganisationTemplatesRouteRoute: typeof authAdminorganisationsOrganisationTemplatesRouteRouteWithChildren
  authAdminorganisationsOrganisationIndexRoute: typeof authAdminorganisationsOrganisationIndexRoute
  authAdminorganisationsOrganisationInformationIndexRoute: typeof authAdminorganisationsOrganisationInformationIndexRoute
}

const authAdminorganisationsOrganisationRouteRouteChildren: authAdminorganisationsOrganisationRouteRouteChildren =
  {
    authAdminorganisationsOrganisationTemplatesRouteRoute:
      authAdminorganisationsOrganisationTemplatesRouteRouteWithChildren,
    authAdminorganisationsOrganisationIndexRoute:
      authAdminorganisationsOrganisationIndexRoute,
    authAdminorganisationsOrganisationInformationIndexRoute:
      authAdminorganisationsOrganisationInformationIndexRoute,
  }

const authAdminorganisationsOrganisationRouteRouteWithChildren =
  authAdminorganisationsOrganisationRouteRoute._addFileChildren(
    authAdminorganisationsOrganisationRouteRouteChildren,
  )

interface authAdminRouteRouteChildren {
  authAdminIndexRoute: typeof authAdminIndexRoute
  authAdminorganisationsOrganisationRouteRoute: typeof authAdminorganisationsOrganisationRouteRouteWithChildren
  authAdminorganisationsOrganisationsIndexRoute: typeof authAdminorganisationsOrganisationsIndexRoute
}

const authAdminRouteRouteChildren: authAdminRouteRouteChildren = {
  authAdminIndexRoute: authAdminIndexRoute,
  authAdminorganisationsOrganisationRouteRoute:
    authAdminorganisationsOrganisationRouteRouteWithChildren,
  authAdminorganisationsOrganisationsIndexRoute:
    authAdminorganisationsOrganisationsIndexRoute,
}

const authAdminRouteRouteWithChildren = authAdminRouteRoute._addFileChildren(
  authAdminRouteRouteChildren,
)

interface authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteChildren {
  authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute
  authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute
  authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute
  authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute
}

const authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteChildren: authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteChildren =
  {
    authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute:
      authProjectsProjectVersionIdApplicationsThoseInvolvedClientIndexRoute,
    authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute:
      authProjectsProjectVersionIdApplicationsThoseInvolvedManagersIndexRoute,
    authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute:
      authProjectsProjectVersionIdApplicationsThoseInvolvedOwnerIndexRoute,
    authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute:
      authProjectsProjectVersionIdApplicationsThoseInvolvedUsersIndexRoute,
  }

const authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteWithChildren =
  authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute._addFileChildren(
    authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteChildren,
  )

interface authProjectsProjectVersionIdApplicationsRouteRouteChildren {
  authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute: typeof authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteWithChildren
  authProjectsProjectVersionIdApplicationsDrawingsIndexRoute: typeof authProjectsProjectVersionIdApplicationsDrawingsIndexRoute
  authProjectsProjectVersionIdApplicationsObjectsIndexRoute: typeof authProjectsProjectVersionIdApplicationsObjectsIndexRoute
  authProjectsProjectVersionIdApplicationsRecapIndexRoute: typeof authProjectsProjectVersionIdApplicationsRecapIndexRoute
  authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute: typeof authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute
}

const authProjectsProjectVersionIdApplicationsRouteRouteChildren: authProjectsProjectVersionIdApplicationsRouteRouteChildren =
  {
    authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRoute:
      authProjectsProjectVersionIdApplicationsThoseInvolvedRouteRouteWithChildren,
    authProjectsProjectVersionIdApplicationsDrawingsIndexRoute:
      authProjectsProjectVersionIdApplicationsDrawingsIndexRoute,
    authProjectsProjectVersionIdApplicationsObjectsIndexRoute:
      authProjectsProjectVersionIdApplicationsObjectsIndexRoute,
    authProjectsProjectVersionIdApplicationsRecapIndexRoute:
      authProjectsProjectVersionIdApplicationsRecapIndexRoute,
    authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute:
      authProjectsProjectVersionIdApplicationsRequestConcerningIndexRoute,
  }

const authProjectsProjectVersionIdApplicationsRouteRouteWithChildren =
  authProjectsProjectVersionIdApplicationsRouteRoute._addFileChildren(
    authProjectsProjectVersionIdApplicationsRouteRouteChildren,
  )

interface authProjectsProjectVersionIdDocumentsRouteRouteChildren {
  authProjectsProjectVersionIdDocumentsIndexRoute: typeof authProjectsProjectVersionIdDocumentsIndexRoute
}

const authProjectsProjectVersionIdDocumentsRouteRouteChildren: authProjectsProjectVersionIdDocumentsRouteRouteChildren =
  {
    authProjectsProjectVersionIdDocumentsIndexRoute:
      authProjectsProjectVersionIdDocumentsIndexRoute,
  }

const authProjectsProjectVersionIdDocumentsRouteRouteWithChildren =
  authProjectsProjectVersionIdDocumentsRouteRoute._addFileChildren(
    authProjectsProjectVersionIdDocumentsRouteRouteChildren,
  )

interface authProjectsProjectVersionIdInspectionPlansRouteRouteChildren {
  authProjectsProjectVersionIdInspectionPlansInformationIndexRoute: typeof authProjectsProjectVersionIdInspectionPlansInformationIndexRoute
  authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute: typeof authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute
}

const authProjectsProjectVersionIdInspectionPlansRouteRouteChildren: authProjectsProjectVersionIdInspectionPlansRouteRouteChildren =
  {
    authProjectsProjectVersionIdInspectionPlansInformationIndexRoute:
      authProjectsProjectVersionIdInspectionPlansInformationIndexRoute,
    authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute:
      authProjectsProjectVersionIdInspectionPlansPlanOfApproachIndexRoute,
  }

const authProjectsProjectVersionIdInspectionPlansRouteRouteWithChildren =
  authProjectsProjectVersionIdInspectionPlansRouteRoute._addFileChildren(
    authProjectsProjectVersionIdInspectionPlansRouteRouteChildren,
  )

interface authProjectsProjectVersionIdQuotationRouteRouteChildren {
  authProjectsProjectVersionIdQuotationIndexRoute: typeof authProjectsProjectVersionIdQuotationIndexRoute
}

const authProjectsProjectVersionIdQuotationRouteRouteChildren: authProjectsProjectVersionIdQuotationRouteRouteChildren =
  {
    authProjectsProjectVersionIdQuotationIndexRoute:
      authProjectsProjectVersionIdQuotationIndexRoute,
  }

const authProjectsProjectVersionIdQuotationRouteRouteWithChildren =
  authProjectsProjectVersionIdQuotationRouteRoute._addFileChildren(
    authProjectsProjectVersionIdQuotationRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsCompletionRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsCompletionIndexRoute: typeof authProjectsProjectVersionIdReInspectionsCompletionIndexRoute
}

const authProjectsProjectVersionIdReInspectionsCompletionRouteRouteChildren: authProjectsProjectVersionIdReInspectionsCompletionRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsCompletionIndexRoute:
      authProjectsProjectVersionIdReInspectionsCompletionIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsCompletionRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsCompletionRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsCompletionRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute
}

const authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteChildren: authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute:
      authProjectsProjectVersionIdReInspectionsControlpointsIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsControlpointsRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsInformationRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsInformationIndexRoute: typeof authProjectsProjectVersionIdReInspectionsInformationIndexRoute
}

const authProjectsProjectVersionIdReInspectionsInformationRouteRouteChildren: authProjectsProjectVersionIdReInspectionsInformationRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsInformationIndexRoute:
      authProjectsProjectVersionIdReInspectionsInformationIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsInformationRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsInformationRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsInformationRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute
}

const authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteChildren: authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute:
      authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute
}

const authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteChildren: authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRoute:
      authProjectsProjectVersionIdReInspectionsPvInvertersInverterIdRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute:
      authProjectsProjectVersionIdReInspectionsPvInvertersIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsSummaryRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsSummaryIndexRoute: typeof authProjectsProjectVersionIdReInspectionsSummaryIndexRoute
}

const authProjectsProjectVersionIdReInspectionsSummaryRouteRouteChildren: authProjectsProjectVersionIdReInspectionsSummaryRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsSummaryIndexRoute:
      authProjectsProjectVersionIdReInspectionsSummaryIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsSummaryRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsSummaryRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsSummaryRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute
}

const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteChildren: authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardChecklistIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardFinalCircuitProtectiveDevicesIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardImpedanceMeasurementsIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardInformationIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardMeasurementsIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentCircuitBreakersIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardResidualCurrentDevicesIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRisoIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute
}

const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteChildren: authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdBoardRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdDeviceObservationsIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdDevicesDistributionBoardDeviceIdResistanceMeasurementsIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute
  authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute
}

const authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteChildren: authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute:
      authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdChecklistIndexRoute,
    authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute:
      authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdInformationIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteChildren,
  )

interface authProjectsProjectVersionIdReInspectionsRouteRouteChildren {
  authProjectsProjectVersionIdReInspectionsCompletionRouteRoute: typeof authProjectsProjectVersionIdReInspectionsCompletionRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsControlpointsRouteRoute: typeof authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsInformationRouteRoute: typeof authProjectsProjectVersionIdReInspectionsInformationRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute: typeof authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsSummaryRouteRoute: typeof authProjectsProjectVersionIdReInspectionsSummaryRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsIndexRoute
  authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute
  authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute: typeof authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute
}

const authProjectsProjectVersionIdReInspectionsRouteRouteChildren: authProjectsProjectVersionIdReInspectionsRouteRouteChildren =
  {
    authProjectsProjectVersionIdReInspectionsCompletionRouteRoute:
      authProjectsProjectVersionIdReInspectionsCompletionRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsControlpointsRouteRoute:
      authProjectsProjectVersionIdReInspectionsControlpointsRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsInformationRouteRoute:
      authProjectsProjectVersionIdReInspectionsInformationRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsPvInvertersRouteRoute:
      authProjectsProjectVersionIdReInspectionsPvInvertersRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsSummaryRouteRoute:
      authProjectsProjectVersionIdReInspectionsSummaryRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsIndexRoute:
      authProjectsProjectVersionIdReInspectionsIndexRoute,
    authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsDistributionboardIdRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRoute:
      authProjectsProjectVersionIdReInspectionsFinalCircuitsFinalCircuitIdRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute:
      authProjectsProjectVersionIdReInspectionsDistributionboardsIndexRoute,
    authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute:
      authProjectsProjectVersionIdReInspectionsFinalCircuitsIndexRoute,
  }

const authProjectsProjectVersionIdReInspectionsRouteRouteWithChildren =
  authProjectsProjectVersionIdReInspectionsRouteRoute._addFileChildren(
    authProjectsProjectVersionIdReInspectionsRouteRouteChildren,
  )

interface authProjectsProjectVersionIdSchedulesRouteRouteChildren {
  authProjectsProjectVersionIdSchedulesIndexRoute: typeof authProjectsProjectVersionIdSchedulesIndexRoute
}

const authProjectsProjectVersionIdSchedulesRouteRouteChildren: authProjectsProjectVersionIdSchedulesRouteRouteChildren =
  {
    authProjectsProjectVersionIdSchedulesIndexRoute:
      authProjectsProjectVersionIdSchedulesIndexRoute,
  }

const authProjectsProjectVersionIdSchedulesRouteRouteWithChildren =
  authProjectsProjectVersionIdSchedulesRouteRoute._addFileChildren(
    authProjectsProjectVersionIdSchedulesRouteRouteChildren,
  )

interface authProjectsProjectVersionIdRouteRouteChildren {
  authProjectsProjectVersionIdApplicationsRouteRoute: typeof authProjectsProjectVersionIdApplicationsRouteRouteWithChildren
  authProjectsProjectVersionIdDocumentsRouteRoute: typeof authProjectsProjectVersionIdDocumentsRouteRouteWithChildren
  authProjectsProjectVersionIdInspectionPlansRouteRoute: typeof authProjectsProjectVersionIdInspectionPlansRouteRouteWithChildren
  authProjectsProjectVersionIdQuotationRouteRoute: typeof authProjectsProjectVersionIdQuotationRouteRouteWithChildren
  authProjectsProjectVersionIdReInspectionsRouteRoute: typeof authProjectsProjectVersionIdReInspectionsRouteRouteWithChildren
  authProjectsProjectVersionIdSchedulesRouteRoute: typeof authProjectsProjectVersionIdSchedulesRouteRouteWithChildren
  authProjectsProjectVersionIdTestProjectFilesIndexRoute: typeof authProjectsProjectVersionIdTestProjectFilesIndexRoute
}

const authProjectsProjectVersionIdRouteRouteChildren: authProjectsProjectVersionIdRouteRouteChildren =
  {
    authProjectsProjectVersionIdApplicationsRouteRoute:
      authProjectsProjectVersionIdApplicationsRouteRouteWithChildren,
    authProjectsProjectVersionIdDocumentsRouteRoute:
      authProjectsProjectVersionIdDocumentsRouteRouteWithChildren,
    authProjectsProjectVersionIdInspectionPlansRouteRoute:
      authProjectsProjectVersionIdInspectionPlansRouteRouteWithChildren,
    authProjectsProjectVersionIdQuotationRouteRoute:
      authProjectsProjectVersionIdQuotationRouteRouteWithChildren,
    authProjectsProjectVersionIdReInspectionsRouteRoute:
      authProjectsProjectVersionIdReInspectionsRouteRouteWithChildren,
    authProjectsProjectVersionIdSchedulesRouteRoute:
      authProjectsProjectVersionIdSchedulesRouteRouteWithChildren,
    authProjectsProjectVersionIdTestProjectFilesIndexRoute:
      authProjectsProjectVersionIdTestProjectFilesIndexRoute,
  }

const authProjectsProjectVersionIdRouteRouteWithChildren =
  authProjectsProjectVersionIdRouteRoute._addFileChildren(
    authProjectsProjectVersionIdRouteRouteChildren,
  )

interface authRouteRouteChildren {
  authAdminRouteRoute: typeof authAdminRouteRouteWithChildren
  authProjectsProjectVersionIdRouteRoute: typeof authProjectsProjectVersionIdRouteRouteWithChildren
  authProjectsIndexRoute: typeof authProjectsIndexRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authAdminRouteRoute: authAdminRouteRouteWithChildren,
  authProjectsProjectVersionIdRouteRoute:
    authProjectsProjectVersionIdRouteRouteWithChildren,
  authProjectsIndexRoute: authProjectsIndexRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  LoginIndexRoute: LoginIndexRoute,
  SsoIndexRoute: SsoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
